import { useEffect, useRef, useState } from 'react';
import * as api from './api';
import language from '../../variables/language';

// Adapted from students/ParticipantSearchSelect.jsx (fetch-all, client-side
// filter, click-outside-to-close dropdown) - the only viable shape here
// too, since GET /api/exercisetemplates has no server-side search param.
export default function ExerciseTemplatePicker({ value, onChange, excludeIds, placeholder }) {
   const [templates, setTemplates] = useState([]);
   const [query, setQuery] = useState('');
   const [open, setOpen] = useState(false);
   const wrapRef = useRef(null);
   const lang = language[language.lang];

   useEffect(() => {
      api.getExerciseTemplates()
         .then(response => setTemplates(Array.isArray(response.data) ? response.data : []))
         .catch(() => setTemplates([]));
   }, []);

   useEffect(() => {
      if(!value) setQuery('');
   }, [value]);

   useEffect(() => {
      const handleOutside = (e) => {
         if(wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
      };
      document.addEventListener('mousedown', handleOutside);
      return () => document.removeEventListener('mousedown', handleOutside);
   }, []);

   const excludeSet = new Set((excludeIds || []).filter(id => id != null).map(String));
   const selected = templates.find(t => String(t.id) === String(value));

   const filtered = templates.filter(t => {
      if(excludeSet.has(String(t.id))) return false;
      if(!query.trim()) return true;
      return (t.name || '').toLowerCase().includes(query.trim().toLowerCase());
   });

   const handlePick = (template) => {
      onChange(String(template.id));
      setQuery(template.name);
      setOpen(false);
   };

   const handleInputChange = (e) => {
      setQuery(e.target.value);
      if(value) onChange('');
   };

   const displayValue = open ? query : (selected ? selected.name : query);

   return (
      <div className='participant-search-select topic-exercise-picker' ref={wrapRef}>
         <input className='submit-field from-input txt-c participant-search-input'
            type='text' placeholder={placeholder}
            value={displayValue}
            onFocus={() => { setOpen(true); setQuery(''); }}
            onChange={handleInputChange} />
         {open ? (
            <div className='participant-search-dropdown'>
               {filtered.length === 0 ? (
                  <div className='participant-search-empty'>{lang['Empty list']}</div>
               ) : filtered.map(t => (
                  <div key={t.id} className='participant-search-option' onClick={() => handlePick(t)}>
                     {t.name}
                     {t.level ? <span className='topic-exercise-badge'>{t.level.name}</span> : ''}
                  </div>
               ))}
            </div>
         ) : ''}
      </div>
   );
}
